var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolderIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14.8,
    height: 14.8,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_101_90",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_101_90",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgEAQAAACJ4248AAAAIGNIUk0AAHomAACAhAAA+gAAAIDoAAB1MAAA6mAAADqYAAAXcJy6UTwAAAACYktHRAAAqo0jMgAAAAlwSFlzAAAAYAAAAGAA8GtCzwAAAAd0SU1FB+cDHw0hDuuwFzQAAAGMSURBVFjD7Ze9agJBFIXPDNu42imCInY+QhptBEmT1qew0LWx8QG0TUqJj2CpVgmSNIG0SbkKWgoiiD+NmZNiYjYJGNbNmh+yB5adZe/M+ebOwt4L/HeJ3YDM5YBCATDN/eHzOdjrCfn46BsBKSXZbtO1lKJqNHwEqFadxRcLquFw78XNxoltNn0CGI30xgYDMhT6NFbFYuT9vQNRr/sA8PSkFyuX3cVHo+TDg3MilcpX/A1ASj3cbt1MEGI2I09PgdtbIJOBuLggz86A8did5XoNXl8L2e2+7GinUumgzKl0msq23X+8H9XpUBmG4TV1Qk4m5MkJYFlAPg9EIu5mJhJAMgkUixC1mucMeBWVYVD1+9pzPJbfYfo+c9stRK+nn1KpbwfQUkrfpfwhAEcBQAAQAAQAAcBvANj9GLzXBodr56XUQUWpHyJNk7y50Z62LUjLAs7P9evlEpxOj0og4vHX6omWpRsTdXnpvbbzqlaLlPJNa5bN6tYsHD7uIaxWwNWVEHd3x/X5K3oG2lXgEpTG7goAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjMtMDMtMzFUMTM6MzM6MTQrMDA6MDABtfM5AAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIzLTAzLTMxVDEzOjMzOjE0KzAwOjAwcOhLhQAAACh0RVh0ZGF0ZTp0aW1lc3RhbXAAMjAyMy0wMy0zMVQxMzozMzoxNCswMDowMCf9aloAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder_icon.b756f8b0bd3ba78eb1e84b021ae580a9.svg";
export { ForwardRef as ReactComponent };